var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "AV / pause"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_5938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 12,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.2646C10 18.3646 9.1 19.2646 8 19.2646C6.9 19.2646 6 18.3646 6 17.2646V7.26465C6 6.16465 6.9 5.26465 8 5.26465C9.1 5.26465 10 6.16465 10 7.26465V17.2646ZM14 17.2646V7.26465C14 6.16465 14.9 5.26465 16 5.26465C17.1 5.26465 18 6.16465 18 7.26465V17.2646C18 18.3646 17.1 19.2646 16 19.2646C14.9 19.2646 14 18.3646 14 17.2646Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_5938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color Fill",
    y: 0.264648,
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseRounded);
export default __webpack_public_path__ + "static/media/pause_rounded.c0907feff60aec0ced2395463fd0e90b.svg";
export { ForwardRef as ReactComponent };